import { Injectable } from '@angular/core';
import { Observable, Subject , BehaviorSubject } from 'rxjs';
import { ContainerEvents } from '../pages/doc-upload';
import { S3 } from 'aws-sdk';
import { S3Factory } from '../../utils';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AuthService } from './auth.service';
import { User } from '../model/types';
import { AnalysisDetails, Analyte, FileObject } from '../model/analysis-details.model';
import  awsconfig, { environment } from '../../environments/environment';
import { Router } from '@angular/router';

import { AuthNewService } from './auth-new.service';
import {Amplify} from 'aws-amplify';
import { delay } from 'rxjs/operators';
import { error } from 'console';
import { StorageService } from './storage.service';



@Injectable({
    providedIn: 'root'
})
export class UploadService {
    disabledValue = new BehaviorSubject<boolean>(true);

    isSubmit?: boolean;
    // Observable string sources
    private uploadContainerEventSource = new Subject<ContainerEvents>();
    private fileUploadEventSource = new Subject<FileObject>();
    URL: string = environment.serverUrl + '/analysis-data';
    BUCKET: string = environment.bucket;
    uploadFileStatus = new Subject();


    // Observable string streams
    uploadContrainerEvent$ = this.uploadContainerEventSource.asObservable();
    fileUploadEvent$ = this.fileUploadEventSource.asObservable();
    private signedInUser?: User;
    private region: string;
    private analysis?: Analyte;
    fileCount = 0;
    progressCount = 0;
    userAttributes?:string;
    UploadFileURL: string = environment.serverUrl + '/upload-data';

    constructor(private http: HttpClient,
        private newAuthService: AuthNewService,
        private router: Router,
        private storageservice: StorageService) {
        this.region = environment.defaultRegion || 'us-east-2';
        Amplify.configure(awsconfig);

        this.newAuthService.getCurrentUser();

        this.newAuthService.getCurrentLoginUser.subscribe((user: any) => {
            this.signedInUser = user;
            this.userAttributes = user.attributes;
            if (!this.signedInUser) {
                this.router.navigate(['/extra-layout/signin']);
                return;
            }
        });
    }

    setSignedInUser(user: User) {
        this.signedInUser = user;
    }

    setAnalysisData(enterData: Analyte) {

        this.analysis = enterData;
        return false;
    }

    // Upload status updates
    publishUploadContainerEvent(event: ContainerEvents) {

        this.uploadContainerEventSource.next(event);
    }

    publishFileUploadEvent(file: FileObject) {
        this.fileUploadEventSource.next(file);
    }

    setRegion(region: string) {
        this.region = region;
    }

    private preparePutObjectRequest(file: File, region: string): S3.Types.PutObjectRequest {
        const obj = {
            Key: [this.analysis?.tempPath,
            file.name].join('/'),
            Bucket: this.BUCKET,
            Body: file,
            ContentType: file.type
        };
        return obj;
    }

    upload(file: File, progressCallback: (error: Error|null, progress: number|undefined, speed: number|undefined) => void, region?: string) {

        region = region || this.region;
        const s3Upload = S3Factory.getS3(region).upload(this.preparePutObjectRequest(file, region));
        s3Upload.on('httpUploadProgress', this.handleS3UploadProgress(progressCallback));
        s3Upload.send(this.handleS3UploadComplete(progressCallback));
        this.fileCount++;
        return s3Upload;
    }

    uploadFile(file: { name: string; files: any; }, file_path: string): Observable<any> {
        const httpOptions = {
            headers: new HttpHeaders({
                'file-name': file_path + '/' + file.name,

            })
        };
        // this.uploadFileStatus.next("Uploading")
        return this.http.post<any>(this.UploadFileURL, file.files, httpOptions);
    }

//     SuccessUpload() {
//         this.uploadFileStatus.next("Uploaded")
//     }
//     FailedUploaded() {
// this.uploadFileStatus.next("Failed")
//     }
    private handleS3UploadProgress(progressCallback: (error: Error|null, progress: number, speed: number) => void) {
        let uploadStartTime = new Date().getTime();
        let uploadedBytes = 0;
        return (progressEvent: S3.ManagedUpload.Progress) => {
            const currentTime = new Date().getTime();
            const timeElapsedInSeconds = (currentTime - uploadStartTime) / 1000;
            if (timeElapsedInSeconds > 0) {
                const speed = (progressEvent.loaded - uploadedBytes) / timeElapsedInSeconds;
                const progress = Math.floor((progressEvent.loaded * 100) / progressEvent.total);

                if (progress === 100) {
                    this.progressCount++;


                    if (this.progressCount === this.fileCount) {
                        this.disabledValue.next(false);
                    }
                }
                progressCallback(null, progress, speed);
                uploadStartTime = currentTime;
                uploadedBytes = progressEvent.loaded;
            }
        };
    }

    private handleS3UploadComplete(
        progressCallback: (error: Error|null, progress: number|undefined, speed: number|undefined) => void) {
        return (error: AWS.AWSError|null, data: S3.ManagedUpload.SendData) => {
            if (error) {
                progressCallback(error, undefined, undefined);
            } else {
                progressCallback(error, 100, undefined);
            }
        };
    }

    cancel(s3Upload: S3.ManagedUpload) {
        s3Upload.abort();
    }


    // Added to check Commit
    submitForAnalysis(analysisDetailObj: AnalysisDetails) {
        this.disabledValue.next(true);
        const userAttributes= this.storageservice.get('access');
        if (userAttributes === 'SU' || userAttributes === 'GA' || userAttributes === 'PI') {

            analysisDetailObj.analysisStatus = 'NewAnalysis';

            return this.http.post(this.URL, analysisDetailObj);
        }
    }

}
